import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormSite } from './FormSite';

import { Dialog } from 'primereact/dialog';

export const ModalSite = (props) => {
    const{
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveCreate, saveUpdate, saveDelete,
        validaciones, name,

        closeDialog
    }=props;


    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >

            {
                method === "create"
                ?<FormSite
                    button = {ModalButtonSave}
                    {...{toggle, loading, handleInputChange, validaciones, closeDialog,  methodAction: saveCreate,}}
                />
                :
                (method === "update")
                ?
                <FormSite
                    button={ModalButtonUpdate}
                    {...{ toggle, loading, handleInputChange, validaciones, closeDialog,methodAction: saveUpdate, name }}
                />
                :
                null
            }
        </Dialog>
    )
}